// extracted by mini-css-extract-plugin
export default {"MainContainer":"FinancesView_MainContainer__1u+4P","Container":"FinancesView_Container__wvgJG","Caselinks":"FinancesView_Caselinks__FZ5D8"};